import { Autocomplete, TextField, Tooltip } from 'components/mui';
import { COMPANIES } from 'containers/pages/contacts/constants';
import { array, func, object } from 'prop-types';

/**
 * @component CompanySelector
 * @param {Object} props
 * @param {Company[]} props.value
 * @param {Company[]} props.options
 * @param {function} props.handleForm
 * @param {ContactValid} props.valid
 * @returns {JSX.Element}
 */
function CompanySelector({ value = [], options, handleForm, valid }) {
	const onChange = (e, newValues) => {
		e.target.name = COMPANIES;
		handleForm(e, newValues);
	};

	return (
		<Autocomplete
			multiple
			value={value}
			options={options}
			getOptionLabel={(option) => option.Name}
			getOptionKey={(option) => option.Id}
			onChange={onChange}
			renderInput={(params) => (
				<Tooltip title="A user must be associated with at least one company." arrow placement="left-start">
				<TextField
					{...params}
					variant="outlined"
					label="Companies"
					required={true}
					InputLabelProps={{ shrink: true }}
					error={valid?.isErr}
					helperText={valid?.errMsg}
				/>
				</Tooltip>
			)}
		/>
	);
}

CompanySelector.propTypes = {
	value: array,
	options: array,
	handleForm: func,
	valid: object,
};

export default CompanySelector;
